import { Typography } from 'antd';
import { FC } from 'react';
import styles from './FilePickerComponents.module.scss';

const { Paragraph } = Typography;

type FilePickerFolderInfoProps = {
  foldersCount?: number;
  filesCount?: number;
  folderName?: string;
};

const FilePickerFolderInfo: FC<FilePickerFolderInfoProps> = ({ foldersCount, filesCount, folderName }) => (
  <div className={styles.folderDataContainer}>
    <div className={styles.folderNameContainer}>
      <Paragraph ellipsis={{ rows: 2, expandable: false }}>{folderName}</Paragraph>
    </div>
    <div className={styles.folderDataDescription}>
      <p>
        {foldersCount ? (foldersCount < 2 ? `${foldersCount} folder` : `${foldersCount} folders`) : ''}
        {foldersCount && filesCount ? ', ' : ''}
        {filesCount ? (filesCount < 2 ? `${filesCount} file` : `${filesCount} files`) : ''}
      </p>
    </div>
  </div>
);

export default FilePickerFolderInfo;
